export default __webpack_public_path__ + "static/media/logo.63e8dbe1.png";